import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_FAQ_ERROR, GET_FAQ_START, GET_FAQ_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/faqs/${payload.lang}` : '/faqs/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_FAQ_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_FAQ_ERROR, error });
  } 
}

export default function* get_faqs() {
  yield takeLatest(GET_FAQ_START, get);
}
